<!-- 公告 -->
<template>
    <div>
        <div class="card"><div class="title">{{ newFormData.name }}</div></div>
        <div class="card mb-0">
            <Form :model="newFormData" label-position="left" :label-width="80">
                <div class="form-title mb-24">公告内容</div>
                <FormItem label="公告图标">
                    <div class="right-uploads w33" @click="openModal">
                        <img class="upload-img w20" v-if="newFormData.content.imgs.picview" :src="newFormData.content.imgs.picview"/>
                        <Icon v-else type="md-add" size="30" color="#ccc"/>
                    </div>
                </FormItem>
                <FormItem label="公告名称">
                    <Input v-model="newFormData.content.title" placeholder="请输入公告名称"></Input>
                </FormItem>
                <FormItem label="公告内容">
                    <Input v-model="newFormData.content.text" placeholder="请输入公告内容"></Input>
                </FormItem>
                <FormItem label="文字大小">
                    <Input v-model="newFormData.content.size" aceholder="请输入文字大小"></Input>
                </FormItem>
                <FormItem label="文字颜色">
                    <ColorPicker v-model="newFormData.content.text_color"/>
                </FormItem>
                <FormItem label="滚动开关">
                    <i-switch v-model="newFormData.content.rollValue" size="large" true-color="#FF761D" :true-value="1" :false-value="0" @on-change="changeRollValue">
                        <span slot="open">开启</span>
                        <span slot="close">关闭</span>
                    </i-switch>
                </FormItem>
                <FormItem v-if="newFormData.content.rollValue" label="滚动时速">
                    <Input v-model="newFormData.content.rollSpeed" placeholder="请输入滚动时速">
                        <span slot="append">px/秒</span>
                    </Input>
                </FormItem>
                <div class="form-title">背景设置</div>
                <FormItem label="背景颜色"><ColorPicker v-model="newFormData.content.bg_color"/></FormItem>
            </Form>
        </div>
        <pictureLibrary v-if="switch_modal" :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/picture/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
        };
    },
    mounted() {},
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.imgs.picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.imgs.value = param2[i];
            }
            this.$Message.destroy();
        },
        openModal() {
            this.switch_modal = true;
        },
        changeRollValue(e){
            this.newFormData.content.rollValue = e;
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.right-uploads {
    margin: 0 12px 0 0;
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #9fa5bb;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.upload-img {
    width: 78px;
    height: 78px;
    border-radius: 5px;
    border: 1px solid #fff;
}
.w33 {
    width: 33px; 
    height: 33px;
}
.w20 {
    width: 20px; 
    height: 20px;
}
</style>